// source: core/protos/scene_canvas.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var core_protos_geometry_pb = require('../../core/protos/geometry_pb.js');
goog.object.extend(proto, core_protos_geometry_pb);
var core_protos_uuid_pb = require('../../core/protos/uuid_pb.js');
goog.object.extend(proto, core_protos_uuid_pb);
var core_protos_material_pb = require('../../core/protos/material_pb.js');
goog.object.extend(proto, core_protos_material_pb);
var core_protos_canvas_items_2d_pb = require('../../core/protos/canvas_items_2d_pb.js');
goog.object.extend(proto, core_protos_canvas_items_2d_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.vertexvis.protobuf.core.CalloutItem', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.Canvas', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.CanvasDocument3d', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.CanvasDocument3d.SealedValueOptionalCase', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.CanvasDocument3dV1', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.CanvasItem', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.CanvasItem.ItemCase', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.Pin2d', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.Canvas = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.Canvas, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.Canvas.displayName = 'proto.vertexvis.protobuf.core.Canvas';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.CanvasDocument3d = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.vertexvis.protobuf.core.CanvasDocument3d.oneofGroups_);
};
goog.inherits(proto.vertexvis.protobuf.core.CanvasDocument3d, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.CanvasDocument3d.displayName = 'proto.vertexvis.protobuf.core.CanvasDocument3d';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.CanvasDocument3dV1 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vertexvis.protobuf.core.CanvasDocument3dV1.repeatedFields_, null);
};
goog.inherits(proto.vertexvis.protobuf.core.CanvasDocument3dV1, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.CanvasDocument3dV1.displayName = 'proto.vertexvis.protobuf.core.CanvasDocument3dV1';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.CanvasItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.vertexvis.protobuf.core.CanvasItem.oneofGroups_);
};
goog.inherits(proto.vertexvis.protobuf.core.CanvasItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.CanvasItem.displayName = 'proto.vertexvis.protobuf.core.CanvasItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.CalloutItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.CalloutItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.CalloutItem.displayName = 'proto.vertexvis.protobuf.core.CalloutItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.Pin2d = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.Pin2d, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.Pin2d.displayName = 'proto.vertexvis.protobuf.core.Pin2d';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.Canvas.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.Canvas.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.Canvas} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Canvas.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && core_protos_uuid_pb.Uuid2l.toObject(includeInstance, f),
    document: (f = msg.getDocument()) && proto.vertexvis.protobuf.core.CanvasDocument3d.toObject(includeInstance, f),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    modifiedAt: (f = msg.getModifiedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    suppliedId: (f = msg.getSuppliedId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.Canvas}
 */
proto.vertexvis.protobuf.core.Canvas.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.Canvas;
  return proto.vertexvis.protobuf.core.Canvas.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.Canvas} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.Canvas}
 */
proto.vertexvis.protobuf.core.Canvas.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_uuid_pb.Uuid2l;
      reader.readMessage(value,core_protos_uuid_pb.Uuid2l.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.CanvasDocument3d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.CanvasDocument3d.deserializeBinaryFromReader);
      msg.setDocument(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setModifiedAt(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSuppliedId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.Canvas.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.Canvas.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.Canvas} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Canvas.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_uuid_pb.Uuid2l.serializeBinaryToWriter
    );
  }
  f = message.getDocument();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.CanvasDocument3d.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getModifiedAt();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSuppliedId();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional Uuid2l id = 1;
 * @return {?proto.vertexvis.protobuf.core.Uuid2l}
 */
proto.vertexvis.protobuf.core.Canvas.prototype.getId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid2l} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid2l, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid2l|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Canvas} returns this
*/
proto.vertexvis.protobuf.core.Canvas.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Canvas} returns this
 */
proto.vertexvis.protobuf.core.Canvas.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Canvas.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CanvasDocument3d document = 2;
 * @return {?proto.vertexvis.protobuf.core.CanvasDocument3d}
 */
proto.vertexvis.protobuf.core.Canvas.prototype.getDocument = function() {
  return /** @type{?proto.vertexvis.protobuf.core.CanvasDocument3d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.CanvasDocument3d, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.CanvasDocument3d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Canvas} returns this
*/
proto.vertexvis.protobuf.core.Canvas.prototype.setDocument = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Canvas} returns this
 */
proto.vertexvis.protobuf.core.Canvas.prototype.clearDocument = function() {
  return this.setDocument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Canvas.prototype.hasDocument = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.vertexvis.protobuf.core.Canvas.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Canvas} returns this
*/
proto.vertexvis.protobuf.core.Canvas.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Canvas} returns this
 */
proto.vertexvis.protobuf.core.Canvas.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Canvas.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp modified_at = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.vertexvis.protobuf.core.Canvas.prototype.getModifiedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Canvas} returns this
*/
proto.vertexvis.protobuf.core.Canvas.prototype.setModifiedAt = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Canvas} returns this
 */
proto.vertexvis.protobuf.core.Canvas.prototype.clearModifiedAt = function() {
  return this.setModifiedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Canvas.prototype.hasModifiedAt = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue supplied_id = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.vertexvis.protobuf.core.Canvas.prototype.getSuppliedId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Canvas} returns this
*/
proto.vertexvis.protobuf.core.Canvas.prototype.setSuppliedId = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Canvas} returns this
 */
proto.vertexvis.protobuf.core.Canvas.prototype.clearSuppliedId = function() {
  return this.setSuppliedId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Canvas.prototype.hasSuppliedId = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.vertexvis.protobuf.core.CanvasDocument3d.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.vertexvis.protobuf.core.CanvasDocument3d.SealedValueOptionalCase = {
  SEALED_VALUE_OPTIONAL_NOT_SET: 0,
  V1: 1
};

/**
 * @return {proto.vertexvis.protobuf.core.CanvasDocument3d.SealedValueOptionalCase}
 */
proto.vertexvis.protobuf.core.CanvasDocument3d.prototype.getSealedValueOptionalCase = function() {
  return /** @type {proto.vertexvis.protobuf.core.CanvasDocument3d.SealedValueOptionalCase} */(jspb.Message.computeOneofCase(this, proto.vertexvis.protobuf.core.CanvasDocument3d.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.CanvasDocument3d.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.CanvasDocument3d.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.CanvasDocument3d} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.CanvasDocument3d.toObject = function(includeInstance, msg) {
  var f, obj = {
    v1: (f = msg.getV1()) && proto.vertexvis.protobuf.core.CanvasDocument3dV1.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.CanvasDocument3d}
 */
proto.vertexvis.protobuf.core.CanvasDocument3d.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.CanvasDocument3d;
  return proto.vertexvis.protobuf.core.CanvasDocument3d.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.CanvasDocument3d} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.CanvasDocument3d}
 */
proto.vertexvis.protobuf.core.CanvasDocument3d.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.CanvasDocument3dV1;
      reader.readMessage(value,proto.vertexvis.protobuf.core.CanvasDocument3dV1.deserializeBinaryFromReader);
      msg.setV1(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.CanvasDocument3d.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.CanvasDocument3d.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.CanvasDocument3d} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.CanvasDocument3d.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getV1();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.CanvasDocument3dV1.serializeBinaryToWriter
    );
  }
};


/**
 * optional CanvasDocument3dV1 v1 = 1;
 * @return {?proto.vertexvis.protobuf.core.CanvasDocument3dV1}
 */
proto.vertexvis.protobuf.core.CanvasDocument3d.prototype.getV1 = function() {
  return /** @type{?proto.vertexvis.protobuf.core.CanvasDocument3dV1} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.CanvasDocument3dV1, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.CanvasDocument3dV1|undefined} value
 * @return {!proto.vertexvis.protobuf.core.CanvasDocument3d} returns this
*/
proto.vertexvis.protobuf.core.CanvasDocument3d.prototype.setV1 = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.vertexvis.protobuf.core.CanvasDocument3d.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.CanvasDocument3d} returns this
 */
proto.vertexvis.protobuf.core.CanvasDocument3d.prototype.clearV1 = function() {
  return this.setV1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.CanvasDocument3d.prototype.hasV1 = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vertexvis.protobuf.core.CanvasDocument3dV1.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.CanvasDocument3dV1.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.CanvasDocument3dV1.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.CanvasDocument3dV1} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.CanvasDocument3dV1.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.vertexvis.protobuf.core.CanvasItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.CanvasDocument3dV1}
 */
proto.vertexvis.protobuf.core.CanvasDocument3dV1.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.CanvasDocument3dV1;
  return proto.vertexvis.protobuf.core.CanvasDocument3dV1.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.CanvasDocument3dV1} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.CanvasDocument3dV1}
 */
proto.vertexvis.protobuf.core.CanvasDocument3dV1.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new proto.vertexvis.protobuf.core.CanvasItem;
      reader.readMessage(value,proto.vertexvis.protobuf.core.CanvasItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.CanvasDocument3dV1.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.CanvasDocument3dV1.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.CanvasDocument3dV1} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.CanvasDocument3dV1.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.CanvasItem.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CanvasItem items = 2;
 * @return {!Array<!proto.vertexvis.protobuf.core.CanvasItem>}
 */
proto.vertexvis.protobuf.core.CanvasDocument3dV1.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.vertexvis.protobuf.core.CanvasItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vertexvis.protobuf.core.CanvasItem, 2));
};


/**
 * @param {!Array<!proto.vertexvis.protobuf.core.CanvasItem>} value
 * @return {!proto.vertexvis.protobuf.core.CanvasDocument3dV1} returns this
*/
proto.vertexvis.protobuf.core.CanvasDocument3dV1.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.vertexvis.protobuf.core.CanvasItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.core.CanvasItem}
 */
proto.vertexvis.protobuf.core.CanvasDocument3dV1.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.vertexvis.protobuf.core.CanvasItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.core.CanvasDocument3dV1} returns this
 */
proto.vertexvis.protobuf.core.CanvasDocument3dV1.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.vertexvis.protobuf.core.CanvasItem.oneofGroups_ = [[1,2,3,4,5]];

/**
 * @enum {number}
 */
proto.vertexvis.protobuf.core.CanvasItem.ItemCase = {
  ITEM_NOT_SET: 0,
  LINE_2D: 1,
  OVAL: 2,
  FREEFORM: 3,
  CALLOUT: 4,
  PIN: 5
};

/**
 * @return {proto.vertexvis.protobuf.core.CanvasItem.ItemCase}
 */
proto.vertexvis.protobuf.core.CanvasItem.prototype.getItemCase = function() {
  return /** @type {proto.vertexvis.protobuf.core.CanvasItem.ItemCase} */(jspb.Message.computeOneofCase(this, proto.vertexvis.protobuf.core.CanvasItem.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.CanvasItem.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.CanvasItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.CanvasItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.CanvasItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    line2d: (f = msg.getLine2d()) && core_protos_canvas_items_2d_pb.LineItem2d.toObject(includeInstance, f),
    oval: (f = msg.getOval()) && core_protos_canvas_items_2d_pb.OvalItem2d.toObject(includeInstance, f),
    freeform: (f = msg.getFreeform()) && core_protos_canvas_items_2d_pb.FreeformItem2d.toObject(includeInstance, f),
    callout: (f = msg.getCallout()) && proto.vertexvis.protobuf.core.CalloutItem.toObject(includeInstance, f),
    pin: (f = msg.getPin()) && proto.vertexvis.protobuf.core.Pin2d.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.CanvasItem}
 */
proto.vertexvis.protobuf.core.CanvasItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.CanvasItem;
  return proto.vertexvis.protobuf.core.CanvasItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.CanvasItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.CanvasItem}
 */
proto.vertexvis.protobuf.core.CanvasItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_canvas_items_2d_pb.LineItem2d;
      reader.readMessage(value,core_protos_canvas_items_2d_pb.LineItem2d.deserializeBinaryFromReader);
      msg.setLine2d(value);
      break;
    case 2:
      var value = new core_protos_canvas_items_2d_pb.OvalItem2d;
      reader.readMessage(value,core_protos_canvas_items_2d_pb.OvalItem2d.deserializeBinaryFromReader);
      msg.setOval(value);
      break;
    case 3:
      var value = new core_protos_canvas_items_2d_pb.FreeformItem2d;
      reader.readMessage(value,core_protos_canvas_items_2d_pb.FreeformItem2d.deserializeBinaryFromReader);
      msg.setFreeform(value);
      break;
    case 4:
      var value = new proto.vertexvis.protobuf.core.CalloutItem;
      reader.readMessage(value,proto.vertexvis.protobuf.core.CalloutItem.deserializeBinaryFromReader);
      msg.setCallout(value);
      break;
    case 5:
      var value = new proto.vertexvis.protobuf.core.Pin2d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.Pin2d.deserializeBinaryFromReader);
      msg.setPin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.CanvasItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.CanvasItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.CanvasItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.CanvasItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLine2d();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_canvas_items_2d_pb.LineItem2d.serializeBinaryToWriter
    );
  }
  f = message.getOval();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_canvas_items_2d_pb.OvalItem2d.serializeBinaryToWriter
    );
  }
  f = message.getFreeform();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      core_protos_canvas_items_2d_pb.FreeformItem2d.serializeBinaryToWriter
    );
  }
  f = message.getCallout();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.vertexvis.protobuf.core.CalloutItem.serializeBinaryToWriter
    );
  }
  f = message.getPin();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.vertexvis.protobuf.core.Pin2d.serializeBinaryToWriter
    );
  }
};


/**
 * optional LineItem2d line_2d = 1;
 * @return {?proto.vertexvis.protobuf.core.LineItem2d}
 */
proto.vertexvis.protobuf.core.CanvasItem.prototype.getLine2d = function() {
  return /** @type{?proto.vertexvis.protobuf.core.LineItem2d} */ (
    jspb.Message.getWrapperField(this, core_protos_canvas_items_2d_pb.LineItem2d, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.LineItem2d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.CanvasItem} returns this
*/
proto.vertexvis.protobuf.core.CanvasItem.prototype.setLine2d = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.vertexvis.protobuf.core.CanvasItem.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.CanvasItem} returns this
 */
proto.vertexvis.protobuf.core.CanvasItem.prototype.clearLine2d = function() {
  return this.setLine2d(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.CanvasItem.prototype.hasLine2d = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional OvalItem2d oval = 2;
 * @return {?proto.vertexvis.protobuf.core.OvalItem2d}
 */
proto.vertexvis.protobuf.core.CanvasItem.prototype.getOval = function() {
  return /** @type{?proto.vertexvis.protobuf.core.OvalItem2d} */ (
    jspb.Message.getWrapperField(this, core_protos_canvas_items_2d_pb.OvalItem2d, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.OvalItem2d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.CanvasItem} returns this
*/
proto.vertexvis.protobuf.core.CanvasItem.prototype.setOval = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.vertexvis.protobuf.core.CanvasItem.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.CanvasItem} returns this
 */
proto.vertexvis.protobuf.core.CanvasItem.prototype.clearOval = function() {
  return this.setOval(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.CanvasItem.prototype.hasOval = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional FreeformItem2d freeform = 3;
 * @return {?proto.vertexvis.protobuf.core.FreeformItem2d}
 */
proto.vertexvis.protobuf.core.CanvasItem.prototype.getFreeform = function() {
  return /** @type{?proto.vertexvis.protobuf.core.FreeformItem2d} */ (
    jspb.Message.getWrapperField(this, core_protos_canvas_items_2d_pb.FreeformItem2d, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.FreeformItem2d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.CanvasItem} returns this
*/
proto.vertexvis.protobuf.core.CanvasItem.prototype.setFreeform = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.vertexvis.protobuf.core.CanvasItem.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.CanvasItem} returns this
 */
proto.vertexvis.protobuf.core.CanvasItem.prototype.clearFreeform = function() {
  return this.setFreeform(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.CanvasItem.prototype.hasFreeform = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional CalloutItem callout = 4;
 * @return {?proto.vertexvis.protobuf.core.CalloutItem}
 */
proto.vertexvis.protobuf.core.CanvasItem.prototype.getCallout = function() {
  return /** @type{?proto.vertexvis.protobuf.core.CalloutItem} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.CalloutItem, 4));
};


/**
 * @param {?proto.vertexvis.protobuf.core.CalloutItem|undefined} value
 * @return {!proto.vertexvis.protobuf.core.CanvasItem} returns this
*/
proto.vertexvis.protobuf.core.CanvasItem.prototype.setCallout = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.vertexvis.protobuf.core.CanvasItem.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.CanvasItem} returns this
 */
proto.vertexvis.protobuf.core.CanvasItem.prototype.clearCallout = function() {
  return this.setCallout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.CanvasItem.prototype.hasCallout = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Pin2d pin = 5;
 * @return {?proto.vertexvis.protobuf.core.Pin2d}
 */
proto.vertexvis.protobuf.core.CanvasItem.prototype.getPin = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Pin2d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.Pin2d, 5));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Pin2d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.CanvasItem} returns this
*/
proto.vertexvis.protobuf.core.CanvasItem.prototype.setPin = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.vertexvis.protobuf.core.CanvasItem.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.CanvasItem} returns this
 */
proto.vertexvis.protobuf.core.CanvasItem.prototype.clearPin = function() {
  return this.setPin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.CanvasItem.prototype.hasPin = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.CalloutItem.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.CalloutItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.CalloutItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.CalloutItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    primaryColor: (f = msg.getPrimaryColor()) && core_protos_material_pb.RGBAi.toObject(includeInstance, f),
    accentColor: (f = msg.getAccentColor()) && core_protos_material_pb.RGBAi.toObject(includeInstance, f),
    text: jspb.Message.getFieldWithDefault(msg, 3, ""),
    anchorPosition: (f = msg.getAnchorPosition()) && core_protos_geometry_pb.Vector3d.toObject(includeInstance, f),
    textPosition: (f = msg.getTextPosition()) && core_protos_geometry_pb.Vector2d.toObject(includeInstance, f),
    sceneItemId: (f = msg.getSceneItemId()) && core_protos_uuid_pb.Uuid2l.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.CalloutItem}
 */
proto.vertexvis.protobuf.core.CalloutItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.CalloutItem;
  return proto.vertexvis.protobuf.core.CalloutItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.CalloutItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.CalloutItem}
 */
proto.vertexvis.protobuf.core.CalloutItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_material_pb.RGBAi;
      reader.readMessage(value,core_protos_material_pb.RGBAi.deserializeBinaryFromReader);
      msg.setPrimaryColor(value);
      break;
    case 2:
      var value = new core_protos_material_pb.RGBAi;
      reader.readMessage(value,core_protos_material_pb.RGBAi.deserializeBinaryFromReader);
      msg.setAccentColor(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 4:
      var value = new core_protos_geometry_pb.Vector3d;
      reader.readMessage(value,core_protos_geometry_pb.Vector3d.deserializeBinaryFromReader);
      msg.setAnchorPosition(value);
      break;
    case 5:
      var value = new core_protos_geometry_pb.Vector2d;
      reader.readMessage(value,core_protos_geometry_pb.Vector2d.deserializeBinaryFromReader);
      msg.setTextPosition(value);
      break;
    case 6:
      var value = new core_protos_uuid_pb.Uuid2l;
      reader.readMessage(value,core_protos_uuid_pb.Uuid2l.deserializeBinaryFromReader);
      msg.setSceneItemId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.CalloutItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.CalloutItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.CalloutItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.CalloutItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrimaryColor();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_material_pb.RGBAi.serializeBinaryToWriter
    );
  }
  f = message.getAccentColor();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_material_pb.RGBAi.serializeBinaryToWriter
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAnchorPosition();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      core_protos_geometry_pb.Vector3d.serializeBinaryToWriter
    );
  }
  f = message.getTextPosition();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      core_protos_geometry_pb.Vector2d.serializeBinaryToWriter
    );
  }
  f = message.getSceneItemId();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      core_protos_uuid_pb.Uuid2l.serializeBinaryToWriter
    );
  }
};


/**
 * optional RGBAi primary_color = 1;
 * @return {?proto.vertexvis.protobuf.core.RGBAi}
 */
proto.vertexvis.protobuf.core.CalloutItem.prototype.getPrimaryColor = function() {
  return /** @type{?proto.vertexvis.protobuf.core.RGBAi} */ (
    jspb.Message.getWrapperField(this, core_protos_material_pb.RGBAi, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.RGBAi|undefined} value
 * @return {!proto.vertexvis.protobuf.core.CalloutItem} returns this
*/
proto.vertexvis.protobuf.core.CalloutItem.prototype.setPrimaryColor = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.CalloutItem} returns this
 */
proto.vertexvis.protobuf.core.CalloutItem.prototype.clearPrimaryColor = function() {
  return this.setPrimaryColor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.CalloutItem.prototype.hasPrimaryColor = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RGBAi accent_color = 2;
 * @return {?proto.vertexvis.protobuf.core.RGBAi}
 */
proto.vertexvis.protobuf.core.CalloutItem.prototype.getAccentColor = function() {
  return /** @type{?proto.vertexvis.protobuf.core.RGBAi} */ (
    jspb.Message.getWrapperField(this, core_protos_material_pb.RGBAi, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.RGBAi|undefined} value
 * @return {!proto.vertexvis.protobuf.core.CalloutItem} returns this
*/
proto.vertexvis.protobuf.core.CalloutItem.prototype.setAccentColor = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.CalloutItem} returns this
 */
proto.vertexvis.protobuf.core.CalloutItem.prototype.clearAccentColor = function() {
  return this.setAccentColor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.CalloutItem.prototype.hasAccentColor = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string text = 3;
 * @return {string}
 */
proto.vertexvis.protobuf.core.CalloutItem.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.vertexvis.protobuf.core.CalloutItem} returns this
 */
proto.vertexvis.protobuf.core.CalloutItem.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Vector3d anchor_position = 4;
 * @return {?proto.vertexvis.protobuf.core.Vector3d}
 */
proto.vertexvis.protobuf.core.CalloutItem.prototype.getAnchorPosition = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3d} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Vector3d, 4));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.CalloutItem} returns this
*/
proto.vertexvis.protobuf.core.CalloutItem.prototype.setAnchorPosition = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.CalloutItem} returns this
 */
proto.vertexvis.protobuf.core.CalloutItem.prototype.clearAnchorPosition = function() {
  return this.setAnchorPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.CalloutItem.prototype.hasAnchorPosition = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Vector2d text_position = 5;
 * @return {?proto.vertexvis.protobuf.core.Vector2d}
 */
proto.vertexvis.protobuf.core.CalloutItem.prototype.getTextPosition = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector2d} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Vector2d, 5));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector2d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.CalloutItem} returns this
*/
proto.vertexvis.protobuf.core.CalloutItem.prototype.setTextPosition = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.CalloutItem} returns this
 */
proto.vertexvis.protobuf.core.CalloutItem.prototype.clearTextPosition = function() {
  return this.setTextPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.CalloutItem.prototype.hasTextPosition = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Uuid2l scene_item_id = 6;
 * @return {?proto.vertexvis.protobuf.core.Uuid2l}
 */
proto.vertexvis.protobuf.core.CalloutItem.prototype.getSceneItemId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid2l} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid2l, 6));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid2l|undefined} value
 * @return {!proto.vertexvis.protobuf.core.CalloutItem} returns this
*/
proto.vertexvis.protobuf.core.CalloutItem.prototype.setSceneItemId = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.CalloutItem} returns this
 */
proto.vertexvis.protobuf.core.CalloutItem.prototype.clearSceneItemId = function() {
  return this.setSceneItemId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.CalloutItem.prototype.hasSceneItemId = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.Pin2d.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.Pin2d.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.Pin2d} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Pin2d.toObject = function(includeInstance, msg) {
  var f, obj = {
    primaryColor: (f = msg.getPrimaryColor()) && core_protos_material_pb.RGBAi.toObject(includeInstance, f),
    accentColor: (f = msg.getAccentColor()) && core_protos_material_pb.RGBAi.toObject(includeInstance, f),
    position: (f = msg.getPosition()) && core_protos_geometry_pb.Vector3d.toObject(includeInstance, f),
    sceneItemId: (f = msg.getSceneItemId()) && core_protos_uuid_pb.Uuid2l.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.Pin2d}
 */
proto.vertexvis.protobuf.core.Pin2d.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.Pin2d;
  return proto.vertexvis.protobuf.core.Pin2d.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.Pin2d} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.Pin2d}
 */
proto.vertexvis.protobuf.core.Pin2d.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_material_pb.RGBAi;
      reader.readMessage(value,core_protos_material_pb.RGBAi.deserializeBinaryFromReader);
      msg.setPrimaryColor(value);
      break;
    case 2:
      var value = new core_protos_material_pb.RGBAi;
      reader.readMessage(value,core_protos_material_pb.RGBAi.deserializeBinaryFromReader);
      msg.setAccentColor(value);
      break;
    case 3:
      var value = new core_protos_geometry_pb.Vector3d;
      reader.readMessage(value,core_protos_geometry_pb.Vector3d.deserializeBinaryFromReader);
      msg.setPosition(value);
      break;
    case 4:
      var value = new core_protos_uuid_pb.Uuid2l;
      reader.readMessage(value,core_protos_uuid_pb.Uuid2l.deserializeBinaryFromReader);
      msg.setSceneItemId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.Pin2d.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.Pin2d.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.Pin2d} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Pin2d.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrimaryColor();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_material_pb.RGBAi.serializeBinaryToWriter
    );
  }
  f = message.getAccentColor();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_material_pb.RGBAi.serializeBinaryToWriter
    );
  }
  f = message.getPosition();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      core_protos_geometry_pb.Vector3d.serializeBinaryToWriter
    );
  }
  f = message.getSceneItemId();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      core_protos_uuid_pb.Uuid2l.serializeBinaryToWriter
    );
  }
};


/**
 * optional RGBAi primary_color = 1;
 * @return {?proto.vertexvis.protobuf.core.RGBAi}
 */
proto.vertexvis.protobuf.core.Pin2d.prototype.getPrimaryColor = function() {
  return /** @type{?proto.vertexvis.protobuf.core.RGBAi} */ (
    jspb.Message.getWrapperField(this, core_protos_material_pb.RGBAi, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.RGBAi|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Pin2d} returns this
*/
proto.vertexvis.protobuf.core.Pin2d.prototype.setPrimaryColor = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Pin2d} returns this
 */
proto.vertexvis.protobuf.core.Pin2d.prototype.clearPrimaryColor = function() {
  return this.setPrimaryColor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Pin2d.prototype.hasPrimaryColor = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RGBAi accent_color = 2;
 * @return {?proto.vertexvis.protobuf.core.RGBAi}
 */
proto.vertexvis.protobuf.core.Pin2d.prototype.getAccentColor = function() {
  return /** @type{?proto.vertexvis.protobuf.core.RGBAi} */ (
    jspb.Message.getWrapperField(this, core_protos_material_pb.RGBAi, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.RGBAi|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Pin2d} returns this
*/
proto.vertexvis.protobuf.core.Pin2d.prototype.setAccentColor = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Pin2d} returns this
 */
proto.vertexvis.protobuf.core.Pin2d.prototype.clearAccentColor = function() {
  return this.setAccentColor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Pin2d.prototype.hasAccentColor = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Vector3d position = 3;
 * @return {?proto.vertexvis.protobuf.core.Vector3d}
 */
proto.vertexvis.protobuf.core.Pin2d.prototype.getPosition = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3d} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Vector3d, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Pin2d} returns this
*/
proto.vertexvis.protobuf.core.Pin2d.prototype.setPosition = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Pin2d} returns this
 */
proto.vertexvis.protobuf.core.Pin2d.prototype.clearPosition = function() {
  return this.setPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Pin2d.prototype.hasPosition = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Uuid2l scene_item_id = 4;
 * @return {?proto.vertexvis.protobuf.core.Uuid2l}
 */
proto.vertexvis.protobuf.core.Pin2d.prototype.getSceneItemId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid2l} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid2l, 4));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid2l|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Pin2d} returns this
*/
proto.vertexvis.protobuf.core.Pin2d.prototype.setSceneItemId = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Pin2d} returns this
 */
proto.vertexvis.protobuf.core.Pin2d.prototype.clearSceneItemId = function() {
  return this.setSceneItemId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Pin2d.prototype.hasSceneItemId = function() {
  return jspb.Message.getField(this, 4) != null;
};


goog.object.extend(exports, proto.vertexvis.protobuf.core);
